import type { ReactNode } from "react";
import { DialogHeader } from "./DialogHeader";
import { Modal } from "./PortalPrimitives";
import { ModalCloseFooter } from "./ModalCloseFooter";
import { securityLogFilterBarStyles } from "./securityLogStyles";

// Diálogo "Filtros adicionales" de la Bitácora de accesos y la Traza HTTP
// (Seguridad): mismo encabezado fijo, mismo pie con "Cerrar" y mismo
// contenedor de campos en grilla — jscpd lo marcó como clon exacto entre
// `AccessLogScreen.tsx` y `HttpRequestLogScreen.tsx` (quality-gate, revisión
// de duplicación 2026-09-23). Cada pantalla sigue armando sus propios
// `<label>` de campo como `children`.
export function AdvancedFiltersModal({
  eyebrow,
  label,
  width,
  onClose,
  description,
  children,
}: {
  eyebrow: string;
  label: string;
  width: number;
  onClose: () => void;
  description: ReactNode;
  children: ReactNode;
}) {
  return (
    <Modal
      label={label}
      width={width}
      onClose={onClose}
      header={<DialogHeader eyebrow={eyebrow} title="Filtros adicionales" />}
      footer={<ModalCloseFooter onClose={onClose} />}
    >
      <p style={securityLogFilterBarStyles.advancedFilters.description}>
        {description}
      </p>
      <div style={securityLogFilterBarStyles.advancedFilters.fields}>
        {children}
      </div>
    </Modal>
  );
}
